import * as React from 'react'
import * as styles from './confirm.dialog.styl'
import Button, { ButtonProps } from '../../common/button'
import cx from 'classnames'
import { textCancelButton, textSuccessButton } from './configurations'

export interface ConfirmProps {
  title?: React.ReactNode
  message?: React.ReactNode
  options?: {
    onClose?: () => void
  }
  onSuccess?: (onClose?: () => void) => void
  onCancel?: (onClose?: () => void) => void
  autoClose?: boolean
}

const Confirm: React.FC<ConfirmProps> = React.memo((props: ConfirmProps) => {
  const { title, message, onSuccess, onCancel, options, autoClose } = props

  function handleCancel(event: React.MouseEvent<HTMLElement, MouseEvent>) {
    if (typeof onCancel === 'function') onCancel(options?.onClose)
    if (autoClose && typeof options?.onClose === 'function') {
      options.onClose()
    }
  }

  function handleClose(event: React.MouseEvent<HTMLElement, MouseEvent>) {
    if (typeof options?.onClose === 'function') {
      options.onClose()
    }
  }

  function handleSuccess(event: React.MouseEvent<HTMLElement, MouseEvent>) {
    if (typeof onSuccess === 'function') {
      onSuccess(options?.onClose)
    }
    if (autoClose && typeof options?.onClose === 'function') {
      options.onClose()
    }
  }

  const commonBtnProps: Partial<ButtonProps> = {
    className: styles.button
  }

  return (
    <div role={'confirm-dialog'} className={styles.confirmDialog}>
      <div role="header" className={styles.header}>
        {title && (
          <h6 role="title" className={styles.title}>
            {title}
          </h6>
        )}
        <i
          role="confirm-close-btn"
          onClick={handleClose}
          className={cx(styles.closeButton, 'material-icons')}
        >
          close
        </i>
      </div>
      <div role={'confirm-message'} className={styles.body}>
        {message}
      </div>
      <div role="footer" className={styles.footer}>
        <Button
          {...commonBtnProps}
          role="confirm-cancel"
          title={textCancelButton}
          style="secondary"
          onClick={handleCancel}
        />
        <Button
          {...commonBtnProps}
          role="confirm-yes"
          title={textSuccessButton}
          onClick={handleSuccess}
        />
      </div>
    </div>
  )
})

export default Confirm
